import { PrismaClient } from '@prisma/client'

export const UserModel = new PrismaClient().users
